import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import { RefreshIndicator } from "material-ui";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import environment from "../../relay/environment";
import ClientDetail from "./ClientDetail";

@connect(state => ({
  windowHeight: state.Responsive.get("windowHeight")
}))
class Renderer extends React.Component {
  static propTypes = {
    windowHeight: PropTypes.number.isRequired,
    activeClient: PropTypes.string.isRequired
  };

  render() {
    const { windowHeight, activeClient } = this.props;
    const top = (windowHeight - 161) / 2 + 161;

    const loadingEl = (
      <RefreshIndicator top={top} left={900} status="loading" />
    );

    return (
      <QueryRenderer
        environment={environment}
        variables={{
          clientId: activeClient
        }}
        query={graphql`
          query ClientDetailsRenderer_ClientDetails_Query($clientId: ID!) {
            traveler(id: $clientId) {
              id
              cbPlusProfileId
              cbPlusProfileName
              cbPlusCreationDate
              displayName
              fullName
              firstName
              middleName
              lastName
              birthdate
              gender
              smoking
              passportExpiry
              isPrimaryTraveler
              primaryTraveler {
                id
                fullName
              }
              phone {
                label
                value
              }
              email
              address1
              address2
              apt
              city
              state
              country
              zipcode
              currentTier
              insideCircle
              lowPriority
              highPriority
              needsTraining
              needsVetting
              fired
              welcomeCampaign
              welcomeBack
              prospect
              acceptPolicies
              acceptPoliciesTimestamp
              profile
              vipNotes
              profileNotes
              travelers(first: 100) {
                edges {
                  node {
                    id
                    displayName
                    fullName
                    vipNotes
                  }
                }
              }
              trips(first: 100) {
                edges {
                  node {
                    id
                    tripName
                    owner {
                      firstName
                    }
                  }
                }
              }
              responseSet(first: 10) {
                edges {
                  node {
                    id
                    display
                  }
                }
              }
            }
          }
        `}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            const { traveler: client } = props;

            return <ClientDetail client={client} />;
          }

          return loadingEl;
        }}
      />
    );
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Clients/ClientDetailsRenderer.js